import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=461cc938&scoped=true&"
import script from "@/views/Users/Supervisor/CreateDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Supervisor/CreateDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Supervisor/create-dialog.scss?vue&type=style&index=0&id=461cc938&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461cc938",
  null
  
)

export default component.exports